import { createContext } from "react";
import { FormSchema } from "../hooks/useFormSchema";

const BondAppFormContext = createContext<FormSchema>(null!);

export default BondAppFormContext;